var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

/**
 * Ensure the Event Type filter closes when the user taps outside the menu
 * on mobile.
 *
 */
$(document).on('click', function (event) {
  //
  if (!tribe) {
    return;
  }

  let $element = $(event.target);
  let inFilterBar = false;
  let inOption = false;

  while ($element.length) {
    if ($element.hasClass('tribe-filter-bar__form')) {
      inFilterBar = true;
    }

    if ($element.hasClass('select2-results__option')) {
      inOption = true;
    }

    $element = $element.parent();
  }

  if (!inFilterBar || inOption) {
    // Ensure filter bar is closed
    tribe.filterBar.filterToggle.closeAllFilters(
      $(tribe.filterBar.filterToggle.selectors.filterBar)
    );
  }
});

module.exports  = function() { /* Nothing to Export */ };
